import {
  CompanyTabName,
  CompanyTabNanoID,
  CompanyTabPosition,
  CreateCompanyTabCacheKeys,
  CreateCompanyTabGqlQuery
} from '../../companyTabsTypes';

import { ID } from '../../../../types';

import { useEdCreateQuery } from '../../../common/reactQuery/hooks/useEdCreateQuery';
import { ErrorType } from '../../../../utils/parseRequestError';

interface CreateCompanyTabOptions {
  query: CreateCompanyTabGqlQuery;
  cacheKeys?: CreateCompanyTabCacheKeys;
}

export interface CreateCompanyTabInput {
  nanoId?: CompanyTabNanoID;
  companyId: ID;
  name: CompanyTabName;
  content?: string;
  position?: CompanyTabPosition;
}

export type CreateCompanyTabError = ErrorType;

const action = 'createCompanyTab';

function useCreateCompanyTab<CreateCompanyTabRecordType = unknown>({
  query,
  cacheKeys
}: CreateCompanyTabOptions) {
  const {
    createQuery,
    createQueryData,
    createQueryError,
    createQueryErrorMessage,
    createQueryLoading,
    createQueryReset
  } = useEdCreateQuery<
    CreateCompanyTabInput,
    CreateCompanyTabRecordType,
    CreateCompanyTabError,
    CreateCompanyTabRecordType
  >({ action, query, cacheKeys });

  return {
    createCompanyTab: createQuery,
    createCompanyTabData: createQueryData,
    createCompanyTabError: createQueryError,
    createCompanyTabErrorMessage: createQueryErrorMessage,
    createCompanyTabLoading: createQueryLoading,
    createCompanyTabReset: createQueryReset
  };
}

export default useCreateCompanyTab;
